module.exports = __webpack_public_path__ + "static/media/img_id.2585360c.svg";